// extracted by mini-css-extract-plugin
export var navbar = "Navbar-module--navbar--eORoi";
export var navItemHome = "Navbar-module--navItemHome--ucJ3I";
export var navItemNoDropdown = "Navbar-module--navItemNoDropdown--VA487";
export var navItem = "Navbar-module--navItem--Z31SP";